import React, { FC, useContext } from 'react';
import { secondaryCTA } from '../../../../constants/analytics.constants';
import ctaTypes from '../../../../enums/CTA.enums';
import { googleModelsCtaClick } from '../../../../utils/analytics';
import { appendToUrlPath } from '../../../../utils/link.utils';
import CTA from '../../../@shared/CTA';
import { TCtaBlock } from '../../types/productModelsListing.types';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';

const CtaBlock: FC<TCtaBlock> = (props) => {
  const { hasButton, baseUrl, titleUrl, t } = props;
  const {sitecoreContext} = useSitecoreContext();
  const productLine = sitecoreContext?.analytics?.['productLine'] ? sitecoreContext?.analytics?.['productLine'] : undefined;
  const productSeries = sitecoreContext?.analytics?.['productSeries'] ? sitecoreContext?.analytics?.['productSeries'] : undefined;

  if (!hasButton) return null;
  return (
    <div className="product-card__cta-section">
      <CTA
        type={ctaTypes['secondaryBlack']}
        href={appendToUrlPath(baseUrl || '', titleUrl || '')}
        onClick={() => {
          googleModelsCtaClick(
            secondaryCTA,
            productLine,
            productSeries,
            t('cnhi-showMoreButton'),
            appendToUrlPath(baseUrl || '', titleUrl || '')
          );
        }}
      >
        {t('cnhi-showMoreButton')}
      </CTA>
    </div>
  );
};

export default CtaBlock;
